import { Navigate, Outlet, useLocation } from 'react-router-dom'
import useAuth from '../../../hooks/useAuth'

const LoginAuth: React.FC = () => {
  const isAuth = useAuth()
  const location = useLocation()

  if (isAuth) {
    // Get the original location from state, or default to home page
    const from = location.state?.from
    if (from) {
      // Construct the full path including search and hash
      const redirectPath = from.pathname + (from.search || '') + (from.hash || '')
      // Set a flag to prevent role-based redirects
      sessionStorage.setItem('skipRoleRedirect', 'true')
      return <Navigate to={redirectPath} replace />
    }
    return <Navigate to="/" replace />
  }

  return <Outlet />
}

export default LoginAuth
